import styled from 'styled-components';

export const GridContainer = styled.div`
  display: grid;
  grid-template-columns: ${({ gridCols, groupedRows }) =>
    `${groupedRows ? "40px" : ""} ${gridCols}`};
  box-sizing: border-box;
`;

export const Item = styled.div`
  background: ${({ isOdd }) => (isOdd ? "#fff" : "#f2f8fc")};
  height: 40px;
  line-height: 40px;
  border-bottom: 1px solid #dae7f5;
  box-sizing: border-box;
  cursor: default;
  position: relative;
`;

export const HeaderItem = styled.div`
  font-size: 12px;
  height: 30px;
  line-height: 30px;
  color: #69798E;
  background: #fff;
  padding-left: 10px;
  border-bottom: 1px solid #dae7f5;
  font-weight: 500;
`;

export const Chevron = styled.div`
  text-align: center;
  font-size: 20px;
  height: 100%;
  cursor: pointer;
  user-select: none;
  transform: rotate(${({ active }) => active ? "90deg" : "0deg"});
`;

export const ChildRow = styled.div`
  grid-column: 1 / span ${({ length }) => length};
  padding: 1px 0px;
  background: #9699b4;
`;

export const GridInput = styled.input`
  width: 100%;
  border: 1px solid #2b68b2;
  height: 40px;
  padding-left: 10px;
  background: #fff;
  outline: none;
`;

export const Arrow = styled.img`
  position: absolute;
  top: 0px;
  right: 0px;
  height: 5px;
  user-select: none;
`;